import React, { useState, useEffect } from 'react';
import styled from '@emotion/styled';
import { css } from '@emotion/react'
import { Grid, FormControlLabel, Radio, RadioGroup, Card, CardContent, Button, useTheme, Select, MenuItem, FormHelperText } from '@mui/material';

import { useNavigate } from 'react-router-dom';

import PaymentsRoundedIcon from '@mui/icons-material/PaymentsRounded';
import MemoryRoundedIcon from '@mui/icons-material/MemoryRounded';
import AdfScannerRoundedIcon from '@mui/icons-material/AdfScannerRounded';
import PointOfSaleRoundedIcon from '@mui/icons-material/PointOfSaleRounded';
import AccountBalanceWalletRoundedIcon from '@mui/icons-material/AccountBalanceWalletRounded';

import ErrorMessage from '../../../utils/MuiFields/ErrorMessage';

import { useFormikContext, Formik, Form } from 'formik';

import { useFormData } from '../../../contexts/FormData';

import Field from '../../../utils/FormikFields/Field';

import { formatCurrency } from '../../../utils/util';

import { BasicFlex } from '../../../utils/Common';

import { methods } from '../../Payments/helpers';

import { useMutation } from '@tanstack/react-query';

import { processPayment } from '../apiService';

import useSnackbarStore from '../../../store/snackbar';

const TotalBar = styled.div`
  background-color: ${props => props.theme.colors.lightBg};
  font-size: 2rem;
  text-align: center;
  padding: 1rem 3rem;
  border-radius: 5px;
  margin: 1rem 0;
`

const TotalInfo = styled(BasicFlex)`
  max-width: 95%;
  width: 30rem;
  margin: 0 auto;
`

const InfoField = ({ method }) => {
  let label = "";
  switch (method) {
    case "credit_card":
      label = "Last 4 digits of Credit Card";
      break;
    case "check":
      label = "Check Number";
      break;
    default:
      label = "Payment Info";
  }

  return (
    <Field name="info" label={label} size="small" />
  )
}

const ManualForm = ({ balance, method = "credit_card", spreadPayments }) => {

  return (
    <Grid container spacing={2}>
      <Grid size={{xs: 12}}>
        <Field name="amount" label="Payment Amount" type="number" size="small" blur={spreadPayments} />
      </Grid>
      <Grid size={{xs: 12, md: 6}}>
        <Field name="method" label="Payment Method" formFieldType="select" options={methods} size="small" />
      </Grid>
      <Grid size={{xs: 12, md: 6}}>
        <InfoField method={method} />
        <FormHelperText>Last 4 digits of Credit Card, etc.</FormHelperText>
      </Grid>
      {balance || balance === 0 ? <Grid size={{xs: 12}}>
        <TotalBar>
          <TotalInfo >
          <div>Balance Total:</div> 
          <div>{ formatCurrency(balance) }</div>
          </TotalInfo>
          </TotalBar>
      </Grid> : null}
    </Grid>
  )
}

const PaymentForm = ({ dialog = false }) => {

  const { values, setFieldValue } = useFormikContext() || {};

  let total_amount = values.total_amount

  let entry = values?.entry

  let isEdit = values?.payment_id ? true : false;

  const { formValues, setFormValues } = useFormData() || {};

  const spreadPayments = (e) => {
  if (total_amount || total_amount === 0) return;
  let payment_amount = e.target.value;
  let bill_amount, bill_id;
  setFormValues(ofv => {
    if (!ofv.applied_payments?.length) return ofv;
      const newAppliedPayments = [...ofv.applied_payments.map(el => ({ ...el }))];
      newAppliedPayments.forEach(el => {
        if (!el.title) { // indicates main bill
          bill_id = el.bill_id;
          el.selected = payment_amount > 0 ? true : false;
          el.amount = payment_amount > 0 ? Math.min(el.balance, payment_amount) : "";
          bill_amount = el.amount;
          payment_amount -= el.amount;
        } else { // bill items
          el.selected = bill_amount > 0 ? true : false;
          el.amount = bill_amount > 0 ? Math.min(el.balance, bill_amount) : "";
          bill_amount -= el.amount;
        }
      })
      return { ...ofv, applied_payments: newAppliedPayments };
    })
  }
   
  return (
    <Card elevation={0} sx={{borderRadius: '12px', width: '100%'}}>
    <CardContent>
    
      <ManualForm balance={values.balance} method={values.method} spreadPayments={spreadPayments} />

    </CardContent>
    </Card>
      
  )
};

export default PaymentForm;